package com.eladfinish.bible.contest.screens.settings

import com.eladfinish.bible.contest.analytics.AnalyticsConstants
import com.eladfinish.bible.contest.analytics.providers.AnalyticsProvider
import com.eladfinish.bible.contest.arch.ViewModelStore
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.screens.settings.SettingsState.DialogState
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow

class SettingsStore(
    private val assetReader: AssetReader,
    private val analytics: AnalyticsProvider,
) : ViewModelStore<SettingsState, SettingsAction, SettingsEffect>(
    tag = "SettingsStore",
) {

    private val defaultState: SettingsState
        get() = SettingsState(
            isLoading = false,
            dialogState = DialogState.None,
        )

    @ExperimentalCoroutinesApi
    override val stateFlow = MutableStateFlow(defaultState)

    override fun handleAction(action: SettingsAction): SettingsState {
        return when (action) {
            SettingsAction.RandomApproachChanged -> handleRandomApproachChanged()
            is SettingsAction.FontChanged -> handleFontChanged(action.selectedFont)
            is SettingsAction.LanguageSelected -> handleLanguageSelected(action.selectedLanguage)
            SettingsAction.HideDialog -> handleHideDialog()
            is SettingsAction.ApplyFontChange -> handleApplyFontChange()
        }
    }

    private fun handleApplyFontChange(): SettingsState {
        launchEffect {
            sideEffectFlow.emit(SettingsEffect.ApplyFontChange)
        }
        return currentState.copy(dialogState = DialogState.None)
    }

    private fun handleFontChanged(selectedFont: String): SettingsState {
        return currentState.copy(
            dialogState = DialogState.FontPreview(
                selectedFont = selectedFont,
            )
        )
    }

    private fun handleLanguageSelected(selectedLanguage: String): SettingsState {
        analytics.logEvent(AnalyticsConstants.LANGUAGE_SELECTED, mapOf(AnalyticsConstants.LANGUAGE to selectedLanguage))
        return currentState
    }

    private fun handleRandomApproachChanged(): SettingsState {
        val explanation = assetReader.readFile(
            fileName = "other" + assetReader.fileSeparator + "randomApproach.txt"
        )
        return currentState.copy(dialogState = DialogState.RandomApproachExplanation(content = explanation))
    }

    private fun handleHideDialog(): SettingsState {
        return currentState.copy(dialogState = DialogState.None)
    }
}
